// extracted by mini-css-extract-plugin
module.exports = {"headertext":"Review_headertext__Kde8C"};